import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faMoneyBillWave,
  faSmile,
  faPrescriptionBottle,
  faCheckCircle,
  faShieldAlt,
} from '@fortawesome/free-solid-svg-icons';

const vantagens = [
  {
    id: 'vantagem-preco',
    titulo: 'Preço competitivo',
    icone: faMoneyBillWave,
  },
  {
    id: 'vantagem-satisfacao',
    titulo: 'Satisfação dos seus colaboradores',
    icone: faSmile,
  },
  {
    id: 'vantagem-descontos',
    titulo: 'Descontos em farmácias',
    icone: faPrescriptionBottle,
  },
];

export default function VantagensPME() {
  return (
    <div className="w-full bg-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Cabeçalho */}
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            O plano ideal para a sua empresa com a qualidade SulAmérica que você
            já conhece.
          </h2>
          <p className="text-xl text-gray-600 max-w-4xl mx-auto">
            São muitos benefícios para garantir o bem-estar dos seus
            colaboradores e o sucesso do seu negócio.
          </p>
        </div>

        {/* Grid de Vantagens */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {vantagens.map((vantagem) => (
            <div
              key={vantagem.id}
              className="bg-white rounded-lg border-2 border-orange-200 hover:border-orange-400 p-8 transition-all duration-300 hover:shadow-xl text-center"
            >
              <div className="bg-orange-100 w-20 h-20 rounded-full flex items-center justify-center mb-6 mx-auto">
                <FontAwesomeIcon
                  icon={vantagem.icone}
                  className="text-orange-600 text-3xl"
                />
              </div>
              <h3 className="text-xl font-bold text-gray-900">
                {vantagem.titulo}
              </h3>
            </div>
          ))}
        </div>

        {/* Seção Adicional */}
        <div className="mt-16 bg-gradient-to-r from-orange-500 to-orange-700 rounded-lg p-8 md:p-12 text-white">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-3xl font-bold mb-4">
                Cuide da saúde bucal da sua equipe
              </h3>
              <p className="text-orange-100 text-lg mb-6">
                Um sorriso saudável impacta diretamente na produtividade e
                bem-estar dos seus colaboradores. Invista na saúde da sua equipe
                com o plano odontológico empresarial SulAmérica.
              </p>
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <FontAwesomeIcon
                    icon={faCheckCircle}
                    className="text-orange-200 mt-1"
                  />
                  <span>Redução de afastamentos por problemas dentários</span>
                </li>
                <li className="flex items-start gap-3">
                  <FontAwesomeIcon
                    icon={faCheckCircle}
                    className="text-orange-200 mt-1"
                  />
                  <span>Aumento da satisfação e retenção de talentos</span>
                </li>
                <li className="flex items-start gap-3">
                  <FontAwesomeIcon
                    icon={faCheckCircle}
                    className="text-orange-200 mt-1"
                  />
                  <span>Benefício valorizado pelos colaboradores</span>
                </li>
              </ul>
            </div>
            <div className="flex justify-center">
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-8 text-center">
                <FontAwesomeIcon
                  icon={faShieldAlt}
                  className="text-8xl text-white/50 mb-4"
                />
                <p className="text-2xl font-bold">Proteção Completa</p>
                <p className="text-orange-100 mt-2">Para toda a sua empresa</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
